// Module
var code = "<template>\n  <div class=\"table--verticalscroll\">\n    <slot></slot>\n  </div>\n</template>\n";
// Exports
export default code;